export enum Roles {
  SUPER_ADMIN = "admin",
  HUB_ADMIN = "hubadmin",
  UNKNOWN = "unknown",
  MANAGER ='manager',
}